module.exports = __webpack_public_path__ + "static/media/silver-card.76e1c417.png";